import React, { useState, useContext } from "react";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import { MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import { RootStoreContext } from "../../store";
import { observer } from "mobx-react-lite";

const genders = [
  {
    value: "男",
    label: "男",
  },
  {
    value: "女",
    label: "女",
  },
  {
    value: "其他",
    label: "其他",
  },
];

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    fontSize: 12,
    width: 80,
  },
  dense: {
    marginTop: useTheme().spacing(2),
  },
  menu: {
    width: 80,
    fontSize: 13,
  },
}));

function OutlinedTextFields({handleChangeGender}) {
  const classes = useStyles();

  const { PersonalStore } = useContext(RootStoreContext);
  const { gender, updateData } = PersonalStore;
  const [gen, setGen] = useState(gender);

  const handleGen = (item) => {
    setGen(item.target.value);
    updateData("gender", item.target.value);
    handleChangeGender(item.target.value)
  };

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <TextField
        id="outlined-select-gender"
        select
        className={classes.textField}
        value={gen}
        onChange={handleGen}
        InputLabelProps={{ shrink: false }}
        SelectProps={{
          MenuProps: {
            className: classes.menu,
          },
        }}
        margin="normal"
        variant="outlined"
        InputProps={{
          style: {
            fontSize: 13,
            height: 60,
          },
        }}
      >
        {genders.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </form>
  );
}
export default observer(OutlinedTextFields);
